import { render } from "./SignatureChip.vue?vue&type=template&id=b2dc4d4a&scoped=true"
import script from "./SignatureChip.vue?vue&type=script&lang=js"
export * from "./SignatureChip.vue?vue&type=script&lang=js"

import "./SignatureChip.vue?vue&type=style&index=0&id=b2dc4d4a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2dc4d4a"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QTooltip});
